import { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import DatePicker from '../../../../components/calendar/DatePicker'
import moment from 'moment/moment'
import { maximum } from '../../../../components/calendar/calendarUtil'
import CheckBox from '../../../../components/form/CheckBox'
import RadioButton from '../../../../components/form/RadioButton'
import TimeTable from '../../../../components/TimeTable'
import {
  setEndDate,
  setEndDateDisabled,
  setImpressionAll,
  setStartDate,
  setWeeklySchedule,
} from '../adGroupSlice'

const ImpressionSchedule = ({ errors }) => {
  const dispatch = useDispatch()
  const { startDate, endDate, weeklySchedule, endDateDisabled, impressionAll } =
    useSelector(state => state.ad.adGroup.form)
  const handleEndDateDisabledChange = useCallback(
    checked => dispatch(setEndDateDisabled(checked)),
    [dispatch]
  )
  const handleStartDateChange = useCallback(
    date => dispatch(setStartDate(date)),
    [dispatch]
  )
  const handleEndDateChange = useCallback(
    date => dispatch(setEndDate(date)),
    [dispatch]
  )
  const handleImpressionAllChange = useCallback(
    value => dispatch(setImpressionAll(value === 'true')),
    [dispatch]
  )
  const handleWeeklyScheduleChange = useCallback(
    value => dispatch(setWeeklySchedule(value)),
    [dispatch]
  )
  return (
    <div
      className={classNames('area_item', {
        error: errors.date || errors.weeklySchedule,
      })}>
      <strong className="subtit_box">집행기간</strong>
      <div className="cont_card">
        <div className="tit_card">
          <strong className="tit_detail">일자</strong>
        </div>
        <div className="item_card">
          <div className="group_date">
            <div className="group_calendar">
              <DatePicker
                value={startDate}
                onChange={handleStartDateChange}
                min={moment().format(moment.HTML5_FMT.DATE)}
                max={endDate}
                error={errors.date}
              />
              <span className="txt_bar">~</span>
              <DatePicker
                value={endDate}
                onChange={handleEndDateChange}
                min={maximum(startDate, moment().format(moment.HTML5_FMT.DATE))}
                disabled={endDateDisabled}
                error={errors.date}
              />
            </div>
            <CheckBox
              label="미설정"
              name="endDateDisabled"
              checked={endDateDisabled}
              tiaraAction="집행기간_미설정_클릭"
              onCheckedChange={handleEndDateDisabledChange}
            />
          </div>
          {errors.date && <p className="txt_error">{errors.date}</p>}
        </div>
        <div className="tit_card">
          <strong className="tit_detail">요일/시간</strong>
        </div>
        <div className="item_card">
          <ul className="list_radiocheck">
            <li>
              <RadioButton
                name="impressionAll"
                label="가능한 모든 요일/시간 노출"
                value="true"
                tiaraAction="집행기간_모든요일시간_클릭"
                checked={impressionAll}
                onValueChange={handleImpressionAllChange}
              />
            </li>
            <li>
              <RadioButton
                name="impressionAll"
                label="상세설정"
                value="false"
                tiaraAction="집행기간_상세설정_클릭"
                checked={!impressionAll}
                onValueChange={handleImpressionAllChange}
              />
            </li>
          </ul>
          {!impressionAll && (
            <>
              <TimeTable
                weeklySchedule={weeklySchedule}
                onChange={handleWeeklyScheduleChange}
                error={errors.weeklySchedule}
              />
              {errors.weeklySchedule && (
                <p className="txt_error">{errors.weeklySchedule}</p>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}
ImpressionSchedule.propTypes = {
  errors: PropTypes.shape({
    date: PropTypes.string,
    weeklySchedule: PropTypes.string,
  }),
}
export default ImpressionSchedule
